import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import renderDataGridLocaleText from 'utils/data-grid-locale-text';

const useDataGridLocaleText = () => {
  const intl = useIntl();

  return useMemo(() => renderDataGridLocaleText(intl), [intl]);
};

export default useDataGridLocaleText;
